import { makeStyles } from '@material-ui/core/styles';
import { Handle, Position } from '@xyflow/react';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$2,
      background: 'rgba(181, 209, 0, 0.1)',
      padding: '5.5px 8px',
      borderRadius: '12px',
    },
    handle: {
      border: '0 !important',
      borderRadius: '0 !important',
      background: `${color.$3} !important`,
      width: '1px !important',
      height: '1px !important',
      minWidth: '1px !important',
      minHeight: '1px !important',
    },
  },
  {
    name: 'End',
  },
);

const EndComponent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <Handle
        className={classes.handle}
        type="target"
        position={Position.Top}
        style={{ top: 1 }}
      />
      <div className={classes.root}>{t('end-node')}</div>
      <Handle
        className={classes.handle}
        type="source"
        position={Position.Bottom}
        style={{ bottom: 0 }}
      />
    </div>
  );
};

export default EndComponent;
